import React from 'react';

import { AsaphAvatar } from '@/components/shared/Avatar';
import cardStyles from '@/components/TeamMemberCard/TeamMemberCard.module.scss';
import { List, ListItemText } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import styles from './TeamMemberList.module.scss';

export interface TeamMemberListProps {
	loading?: boolean;
	hideHeader?: boolean;
}

export const TeamMemberList: React.FC<TeamMemberListProps> = ({
	children,
	loading = false,
	hideHeader = false,
}) => {
	return (
		<section className={styles['members']}>
			{!hideHeader && (
				<div className={styles['members__header']}>Team Members</div>
			)}
			{loading ? (
				<div className={styles['members__list']}>
					{renderSkeletonItem()}
					{renderSkeletonItem()}
					{renderSkeletonItem()}
					{renderSkeletonItem()}
					{renderSkeletonItem()}
				</div>
			) : (
				<List className={styles['members__list']}>
					{React.Children.toArray(children).filter(Boolean).map((child, index, arr) => (
						<React.Fragment key={index}>
							{child}
							{index < arr.length - 1 && (
								<li className={styles['members__divider-wrapper']} aria-hidden="true">
									<div className={styles['members__divider']} />
								</li>
							)}
						</React.Fragment>
					))}
				</List>
			)}
		</section>
	);
};

function renderSkeletonItem() {
	return (
		<div className={styles['skeleton']}>
			<div className={cardStyles['member__avatar-container']}>
				<Skeleton variant="circle">
					<AsaphAvatar size="small" name="L" />
				</Skeleton>
			</div>
			<ListItemText primary={<Skeleton />} secondary={<Skeleton />} />
		</div>
	);
}
